(function () {
  const section = document.querySelector('.about-scroll');
  if (!section) return;

  const panels = section.querySelectorAll('.about-scroll__panel');
  const images = section.querySelectorAll('.about-scroll__image');

  function activateIndex(index) {
    images.forEach(function (img, i) {
      img.classList.toggle('is-active', i === index);
    });
    panels.forEach(function (panel, i) {
      panel.classList.toggle('is-active', i === index);
    });
  }

  activateIndex(0);

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const index = parseInt(entry.target.dataset.panelIndex, 10);
          activateIndex(index);
        }
      });
    },
    { threshold: 0.5 }
  );

  panels.forEach(function (panel) {
    observer.observe(panel);
  });

  requestAnimationFrame(function () {
    setTimeout(function () {
      images.forEach(function (img) {
        img.classList.add('is-ready');
      });
    }, 100);
  });

})();